import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import GlobalComponents from './utils/globals';
import ElementPlus from 'element-plus';
import VueCookies from 'vue3-cookies';
import VueSocialSharing from 'vue-social-sharing';
import VueMatomo from 'vue-matomo';
import './utils/styles';
import { i18n } from 'vue-lang-router';
import matomo from './utils/matomo';

import './registerServiceWorker';

const app = createApp(App);
app
  .use(store)
  .use(router)
  .use(i18n)
  .use(GlobalComponents)
  .use(ElementPlus)
  .use(VueCookies)
  .use(VueSocialSharing)
  .use(VueMatomo, {
    ...matomo,
    router: router
  })
  .mount('#app');
